// ------------------------------------------------------------------------------------------------------
// VENDOR LIBRARIES

import $ from 'jquery';
window.jQuery = window.$ = $;

import 'bootstrap-sass';
import 'html5shiv';

// ------------------------------------------------------------------------------------------------------
// SITE COMPONENTS

import SiteHeader from './components/site-header';
import VideoHero from './components/video-hero';
import EqualHeightGroup from './components/equal-height-groups';
import Fit from './components/fit';
import ForceRepaint from './components/force-repaint';
import Popup from './components/popup';
import QuestionForm from './components/question-form';
import TeamPopup from './components/team-popup';
import IntlTelInput from 'intl-tel-input';
import Util from 'intl-tel-input/build/js/utils';

// ------------------------------------------------------------------------------------------------------
// APP ENTRY POINT

var App = function () {
};

App.prototype.init = function () {

    var equalHeightGroup = new EqualHeightGroup();

    // Header
    SiteHeader.init();

    // Video Hero
    VideoHero.init();

    Fit.init();
    ForceRepaint.init();

    // Inline Popups
    Popup.init();

    // Question Form
    QuestionForm.init();

    //Team page popups
    TeamPopup.init();

    this.Accordion();
    this.ItineraryButtons();


    $('.navbar-nav a[data-target]').on('click', function () {

        let target = $(this).data('target');
        if ($(target).hasClass('in')) {
            return;
        }

        $('.navbar-nav a').removeClass('in');

        if ($(target + ':hidden')) {
            $(target).addClass('in');
        }
    });


    //booking form country code/phone number input
    var telephoneInput = document.getElementById("phone");
    var bookingForm = document.getElementById("wf-form-Booking-Form");
    if(telephoneInput && bookingForm){
        Window.flagInput = IntlTelInput(telephoneInput,{utilsScript: "intl-tel-input/build/js/utils.js",initialCountry: "gb" });
        
        bookingForm.addEventListener('submit', function() {

            var countryData = Window.flagInput.getSelectedCountryData();
            var dialCode = countryData.dialCode;

            var codeInput = document.getElementById('phone_number_code');
            codeInput.value = "+" + dialCode;
        });
    }

    if ($('input[type="radio"][data-show-element]').length) {

        $('input[type="radio"][data-show-element]').each(function(i, el) {
            updateShownElements($(el));
            $(document).on('change', 'input[type="radio"][name="' + $(el).attr('name') + '"]', function(e) {
                updateShownElements($('input[type="radio"][name="' + $(el).attr('name') + '"][data-show-element]'));
            });
        });

        function updateShownElements($inputs) {
            $inputs.each(function(i, el) {
                var selector = $(el).data('showElement');
                if (!!selector) {
                    var checked = $(el).prop('checked');
                    $(selector).toggle(checked);

                    if (checked) {
                        $(selector + ' input').attr('required', true);
                    } else {
                        $(selector + ' input').removeAttr('required');
                    }
                }
            });
        }
    }

    if ($('#booking-form').length > 0) {
        this.BookingForm($('#booking-form').eq(0));
    }
};

App.prototype.BookingForm = function ($form) {

    var $container = $('#form-types');
    var types = [];

    $container.find('[data-type]').each(function(i, el) {
        types.push($(el).detach());
    });

    updateType();

    $form.on('change', 'input[data-name="type"]', function(e) {
        updateType();
    });

    function updateType() {
        let newType = ($form.find('input[data-name="type"]:checked').eq(0).val() || '').toLowerCase();
        types.forEach(function($el) {
            if ($el.data('type') === newType) {
                $el.addClass('active');
                $el.appendTo($container);
            } else {
                $el.removeClass('active');
                $el.detach();
            }
        });
    }
};

App.prototype.Accordion = function () {

    $('[data-accordion-target]').on('click', function () {
        var $target = $('[data-accordion="' + $(this).data('accordion-target') + '"]');

        if (!$target.hasClass('w-hidden-tiny')) {
            $target.addClass('w-hidden-tiny');
            $(this).html('More Info');

        } else { // if it's closed
            $target.removeClass('w-hidden-tiny');
            $(this).html('Less Info');
        }
        return false;
    });
};

App.prototype.ItineraryButtons = function () {

    $(document).on('click', '[data-action="show-evening-itinerary"]', function (e) {
        let $target = $($(e.currentTarget).data('target'));

        if ($target.hasClass('open')) {
            $(e.currentTarget).html($(e.currentTarget).data('show-text'));
            $target.removeClass('open')
        } else {
            $(e.currentTarget).html($(e.currentTarget).data('hide-text'));
            $target.addClass('open');
        }
    })
};


window.$ = window.jQuery = $;
window.app = new App();
window.app.init();